<template>
  <div class="login">
    <div class="blue-circle top"></div>
    <div class="blue-circle bottom"></div>
    <div class="logo">
      <!-- <img class="img" src="@/assets/images/logo@2x.png" alt="" /> -->
      <p class="t1">CRM移动端管理系统</p>
      <p class="t2">CRM Mobile Management System</p>
    </div>
    <div class="login-cover">
      <img src="@/assets/images/login-cover@2x.png" alt="" />
    </div>

    <div class="login-form">
      <van-field
        type="text"
        v-model.trim="loginForm.username"
        maxlength="12"
        clearable
        placeholder="请输入手机号"
        @change="checkPhone"
      >
        <template #left-icon>
          <i class="iconfont icon-yonghuming"></i>
        </template>
      </van-field>
      <van-field
        :type="!isPassOpen ? 'password' : 'text'"
        v-model.trim="loginForm.password"
        maxlength="12"
        clearable
        placeholder="请输入密码"
        @change="checkPhone"
        :right-icon="!isPassOpen ? 'closed-eye' : 'eye-o'"
        @click-right-icon="isPassOpen = !isPassOpen"
      >
        <template #left-icon>
          <i class="iconfont icon-mima"></i>
        </template>
      </van-field>
      <div class="btns flex">
        <van-button @click="$router.push('/register')" plain type="info"
          >注册账号</van-button
        >
        <van-button @click="$router.push('/password')" plain
          >忘记密码</van-button
        >
      </div>
      <div class="sign">
        <van-button
          color="#3C86FF"
          block
          type="info"
          :loading="loginLoading"
          class="sign-btn"
          @click="login"
          >登录</van-button
        >
      </div>
    </div>

    <!-- <div class="copyright">{{copyright}}</div> -->
  </div>
</template>

<script>
import ApiUser from "@/api/user";
import { Toast } from "vant";
import { storeUserInfo, clearUserInfo } from "@/libs/utils";

export default {
  data() {
    return {
      // 验证码
      totalTime: 60,
      codeContent: "获取验证码",
      isShowCodeText: true,
      clock: "",
      mobile: "",
      password: "",
      errorMessage: {
        mobile: "",
        password: "",
      },
      loginForm: {
        username: process.env.NODE_ENV == "development" ? "luoqiubo" : "",
        password: process.env.NODE_ENV == "development" ? "lqb123456" : "",
        tenantName: "颂车网",
        captchaVerification: "",
      },
      isPassOpen: false,
      loginLoading: false,
      subject: "ENTERPRISE", // 默认选择企业
      subjectData: [],
    };
  },
  computed: {
    copyright() {
      return `CopyRight © Songcw.com 2017 - ${new Date().getFullYear()}`;
    },
  },
  methods: {
    // 登录
    async login() {
      try {
        if (!this.loginForm.username) throw "请输入手机号";
        if (!this.loginForm.password) throw "请输入密码";
        this.loginLoading = true;
        const res = await ApiUser.login(this.loginForm);
        storeUserInfo(res.data);
        const user = await ApiUser.baseInfo();
        let data = {
          ...res.data,
          ...user,
        };
        this.loginSuccess(data);
      } catch (error) {
        Toast.fail(error);
      } finally {
        this.loginLoading = false;
      }
    },

    // 登录成功
    loginSuccess(data) {
      clearUserInfo();
      storeUserInfo(data);
      this.$router.push("/");
    },

    // 验证手机号码格式
    checkPhone() {
      const value = this.mobile;
      const phoneReg = /^1\d{10}$/;
      if (!value) {
        this.errorMessage.mobile = "手机号码不能为空";
        return false;
      }
      if (!phoneReg.test(value)) {
        this.errorMessage.mobile = "手机号码格式错误";
        return false;
      }
      this.errorMessage.mobile = "";
      return true;
    },
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.blue-circle {
  width: 118px;
  height: 10px;
  background: #3c86ff;

  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  &.top {
    border-radius: 0px 0px 100px 100px;
    top: 0px;
  }
  &.bottom {
    border-radius: 100px 100px 0px 0px;
    bottom: 0px;
  }
}
.logo {
  padding: 44px 38px;
  .img {
    width: 49px;
    display: block;
  }
  .t1 {
    margin-top: 20px;
    font-weight: Medium;
    font-size: 20px;
    color: #212528;
    letter-spacing: 0;
  }
  .t2 {
    margin-top: 3px;
    font-weight: Medium;
    font-size: 9px;
    color: #9a9ea1;
    letter-spacing: 0;
  }
}

.login-cover {
  width: 250px;
  margin: 0px auto;
  img {
    max-width: 100%;
  }
}

.login-form {
  position: relative;
  width: 312px;
  min-height: 209px;
  background: #ffffff;
  box-shadow: 0 8px 16px 0 rgba(72, 88, 115, 0.01);
  border-radius: 6px;
  margin: -70px auto 0px auto;
  padding: 28px 23px;

  .van-field {
    align-items: center;
    border: 1px solid #ececec;
    border-radius: 4px;
    font-size: 14px;
    padding: 8px 5px;

    &::after {
      display: none;
    }

    &:nth-child(n + 2) {
      margin-top: 16px;
    }

    /deep/ .van-field__body {
      height: 30px;
    }
    /deep/ .van-field__button {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    ::placeholder {
      font-size: 12px;
    }
  }

  .iconfont {
    color: #9a9ea1;
    text-align: center;
    display: inline-block;
    width: 34px;
    height: 24px;
    overflow: hidden;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    &.icon-mobile {
      // margin-top: 4px;
      font-size: 28px;
    }
    &.icon-sms-solid {
      font-size: 22px;
    }
  }
}

.copyright {
  margin-top: 40px;
  font-weight: Medium;
  font-size: 10px;
  color: #9a9ea1;
  letter-spacing: 0;
  text-align: center;
}

.flex {
  display: flex;
  flex-direction: row;
}

.btns {
  justify-content: space-between;
  button {
    border: none;
  }
}
.code {
  white-space: nowrap;
}

.sign {
  margin-top: 16px;
  border-radius: 3px;

  .sign-btn {
    font-weight: Medium;
    font-size: 15px;
    color: #ffffff;
    letter-spacing: 0;
  }
}
.forget {
  font-size: 14px;
  color: #888;
}
.radio-box {
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
